import { LifecycleStage } from './LifecycleStage';

/** v7.5: reviewed cross-system lifecycle view. */
export function BuildStage() { return <LifecycleStage stage="build" />; }
